// apps/web/src/lib/validators/profile.ts
import { z } from 'zod';

export const ProfileSettingsSchema = z.object({
    fullName: z.string().min(3, "Full name must be at least 3 characters."),
    username: z.string().min(3, "Username must be at least 3 characters.").optional().or(z.literal('')),
    // --- Transporter-specific fields ---
    isPublic: z.boolean().optional(),
    isAvailableToHire: z.boolean().optional(),
    // We will add avatar logic later, so no validation here for now.
});

export type TProfileSettingsSchema = z.infer<typeof ProfileSettingsSchema>;